
import { Component, Prop, Ref, Vue } from "vue-property-decorator"
import LightDarkSwitch from "@/components/Account/LightDarkSwitch.vue"
import NewInterfaceSwitch from "@/components/Account/NewInterfaceSwitch.vue"
import { Action, Getter, Mutation, State } from "vuex-class"
import { CurrentUser } from "@/types/user"
import { LoginResultTenant } from "@/types"
import api from "@/services/api"
import SetStatusModal from "@/components/SetStatusModal.vue"
import tenantApi from "@/services/api_Tenant"
import { TenantSupport } from "@/types/tenant"
import UserSettingsModal from "@/components/UserSettingsModal.vue"
import SureViewSupportModal from "@/components/SureViewSupportModal.vue"
import NewLightDarkSwitch from "@/components/Account/NewLightDarkSwitch.vue"
import { BaseState } from "@/store"

@Component({
	components: {
		NewLightDarkSwitch,
		SureViewSupportModal,
		"light-dark": LightDarkSwitch,
		"new-interface-switch": NewInterfaceSwitch,
		"set-status-modal": SetStatusModal,
		"user-settings-modal": UserSettingsModal
	}
})
export default class UserMenu extends Vue {
	// TODO remove
	@Ref() setStatusModal!: SetStatusModal
	@Ref() userSettingsModal!: UserSettingsModal

	@Getter("getUseV2") usingV2!: boolean

	@Prop({ type: String, required: true })
	pictureUrl!: string;

	@Prop({ type: Boolean, default: false })
	showNewInterfaceSwitch!: boolean;

	@State((state: BaseState) => state.me) public me!: CurrentUser;
	@Getter("hasSubscription") hasSubscription!: boolean;

	@Action("selectTenant")
	public loginSelectTenant!: (tenant: LoginResultTenant) => Promise<void>

	@Action("logOut")
	public logOut!: () => void;

	@Mutation
	private setManualLogout!: (manualLogout: boolean) => void

	supportAccess: TenantSupport | null = null
	supportAccessOpen: boolean = false

	private showSetStatus () {
		this.setStatusModal.open()
	}

	private showUserSettings () {
		this.userSettingsModal.open()
	}

	private async openSupportAccess () {
		this.supportAccess = await tenantApi.tenantAccess()
		this.supportAccessOpen = true
	}

	private allowAccess (time: string | null) {
		tenantApi.openSupportAccess({ value: time })
		this.supportAccessOpen = false
	}

	private endAccess () {
		tenantApi.openSupportAccess({ value: null })
		this.supportAccessOpen = false
	}

	private get otherTenants (): LoginResultTenant[] {
		if (!this.me || !this.me.loginTenants) {
			return []
		}

		return this.me.loginTenants.filter(t => !t.disabled && t.id !== this.me.tenantId)
	}

	public async logout () {
		this.setManualLogout(true)

		await api.logout()
		this.logOut()
	}
}
